import { startLoading, stopLoading } from "./loaderBus"

// A handful of call sites (e.g. Login's 2FA step) use raw fetch() instead of
// axios, so the axios interceptors alone wouldn't cover them. Wrapping the
// global fetch once here keeps the loader accurate without touching every
// call site individually.
const originalFetch = window.fetch.bind(window)

window.fetch = (...args) => {
  startLoading()
  return originalFetch(...args).finally(stopLoading)
}
